<template>
  <div class="only-list-day has--scroll">
    <div
      class="empty-list-day center"
      v-if="!isLoading && (!appointmentList || !appointmentList.length)"
    >
      אין תורים
    </div>
    <app-list-event
      v-for="event in appointmentList"
      :key="event.id"
      :event="event"
    />
  </div>
</template>

<script>
import AppListEvent from "@/components/Dashboard/List/AppListEvent";

export default {
  name: "AppointmentList",
  components: { AppListEvent },
  props: {
    appointmentList: { required: true }
  },
  data() {
    return {
      isLoading: true
    };
  },
  methods: {
    getTime(date) {
      return this.$moment(date).format("LT");
    },
    getScheduledBy(type) {
      return this.$store.getters["getAppScheduledBy"](type, false);
    }
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 300);
  }
};
</script>
